<template>
  <div>
    <h4>
      <b-icon icon="pencil" />
      Poznámky
    </h4>
    <b-btn
      v-if="!showAddNote"
      variant="primary"
      size="sm"
      @click="showAddNote = true"
    >
      <b-icon class="mr-1" icon="plus" scale="1.5x" />
      Pridať
    </b-btn>
    <b-form v-if="showAddNote">
      <b-form-textarea v-model="note" rows="3" autofocus />
      <div class="d-flex justify-content-end">
        <b-btn-group class="ml-auto" size="sm">
          <b-btn variant="outline-secondary" @click="resetNote">
            <b-icon icon="x" scale="1.5x" />
          </b-btn>
          <b-btn type="submit" variant="primary" @click.prevent="saveNote">
            <b-icon class="mr-1" icon="check" scale="1.5x" />
            Uložiť
          </b-btn>
        </b-btn-group>
      </div>
    </b-form>
    <div v-if="!loading" class="my-2">
      <div v-for="note in notes" :key="note.id" class="note">
        <div class="mb-2">
          <span
            class="d-inline-block bg-white rounded fs-sm py-1 px-2"
            v-html="$options.filters.nl2br(note.note)"
          />
        </div>
        <div class="fs-sm ml-2">
          <span class="mr-2"><b-icon icon="person" /> {{ note.userName }}</span>
          <span class="text-muted mr-2"
            ><b-icon icon="clock" />
            {{ note.createdDateTime | formatAgo }}</span
          >
          <span v-if="canEdit(note.userId)" class="actions">
            <b-link class="mr-2" @click="edit(note.id)"
              ><b-icon class="mr-1" icon="pencil-square" />Upraviť</b-link
            >
            <b-link class="mr-2" @click="removeNote(note.id)"
              ><b-icon class="mr-1" icon="trash" />Vymazať</b-link
            >
          </span>
        </div>
      </div>
      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        size="sm"
        :per-page="perPage"
        :total-rows="totalRows"
        pills
        class="my-0"
      />
    </div>
  </div>
</template>
<script>
import operationService from '@/services/api/operationService'
import getPeriod from '../mixins/getPeriod'

export default {
  mixins: [getPeriod],
  data() {
    return {
      loading: false,
      editId: null,
      showAddNote: false,
      note: null,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      notes: [],
    }
  },
  watch: {
    currentPage() {
      this.fetchNotes()
    },
  },
  created() {
    this.fetchNotes()
  },
  methods: {
    fetchNotes(silent = false) {
      this.loading = !silent
      operationService
        .findDeliveryPointNotes({
          orderBy: { createdDateTime: 'desc' },
          startAt: (this.currentPage - 1) * this.perPage,
          maxResults: this.perPage,
          deliveryPointId: this.$store.getters['operation/get'].callback_id,
          periodFrom: this.period.from,
          periodTo: this.period.to,
        })
        .then((res) => {
          this.totalRows = res.headers['x-pagination-total-count']
            ? parseInt(res.headers['x-pagination-total-count'])
            : 0
          this.currentPage = res.headers['x-pagination-current-page']
            ? parseInt(res.headers['x-pagination-current-page']) + 1
            : 0
          this.notes = res.data

          if (!silent) {
            this.loading = false
          }
        })
    },
    saveNote() {
      let data = {
        deliveryPointId: this.$store.getters['operation/get'].callback_id,
        periodFrom: this.period.from.ge,
        periodTo: this.period.to.le,
        note: this.note,
      }
      if (this.note && !this.editId) {
        operationService.createDeliveryPointNote(data).then(() => {
          this.resetNote()
          this.fetchNotes()
        })
      } else if (this.note && this.editId) {
        operationService.updateDeliveryPointNote(this.editId, data).then(() => {
          this.resetNote()
          this.fetchNotes()
        })
      }
    },
    removeNote(id) {
      this.$swal({
        title: 'Ste si istý?',
        html: 'Skutočne chcete vymazať túto poznámku?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          operationService.deleteDeliveryPointNote(id).then(() => {
            this.$swal({
              type: 'success',
              position: 'top',
              showCloseButton: true,
              text: 'Poznámka bola vymazaná',
              timer: 5000,
            })
            this.fetchNotes()
          })
        }
      })
    },
    resetNote() {
      this.note = null
      this.showAddNote = false
      this.editId = null
    },
    canEdit(userId) {
      return userId === this.$store.getters['user/getApiEnergyUser']?.id
    },
    edit(id) {
      this.editId = id
      this.showAddNote = true
      this.note = this.notes.find((item) => item.id === id).note
    },
  },
}
</script>
<style lang="scss">
.note {
  padding: 0.5rem 0;

  .actions {
    display: none;
  }

  &:hover .actions {
    display: inline-block;
  }
}
</style>
